import { useState } from 'react';

import { useTranslation } from 'react-i18next';
import { Link, useNavigate, useParams } from 'react-router-dom';

import { FormStepHeader } from '../components/form-step-header';
import { FileUploader } from '@/new/components/file-uploader';
import { Icon } from '@/new/components/icon';
import { PageContainer } from '@/new/components/page-container';
import { PageHeader } from '@/new/components/page-header';
import { Button } from '@/new/components/shadcn/button';

export type FileUploadState = 'uploading' | 'processing' | 'completed';

export interface UploadTracker {
  fileIds: Set<string>;
  completedCount: number;
  totalCount: number;
  state: FileUploadState;
}

export function MatterCreatorFiles() {
  const { t } = useTranslation();
  const { matterId } = useParams();
  const navigate = useNavigate();

  const handleNextClick = (e: React.MouseEvent) => {
    navigate(`/matters/new/${matterId}/basic`);
  };

  const [filesProcessing, setFilesProcessing] = useState(false);

  return (
    <>
      <PageContainer className="border-b">
        <PageHeader>
          <FormStepHeader
            title="Upload Documents"
            description={`Wexler accepts a wide range of file formats. Try uploading ${t('witness statements')}, emails, or contracts.`}
            step={1}
          >
            <Button variant="primary" onClick={handleNextClick} disabled={filesProcessing}>
              Next: Basic Information
              <Icon className="lucide--arrow-right" />
            </Button>
          </FormStepHeader>
        </PageHeader>
      </PageContainer>

      <FileUploader setFilesProcessing={setFilesProcessing} isMatterCreator={true} />
    </>
  );
}
